console.log('MindsSDK Loyalty initialized');

window.sdk = new MindsSDK.LoyaltyPage({
  apiKey: 'key_live_nTOuUWJxYHY2qaP3HdjS0QsTcaLpameKWL7LvynqYmw',
  platform: 'SHOPIFY',
  shopDomain: 'a22b64-29.myshopify.com',
  useAppProxy: true, // Default is true for Shopify
});

// Function to update loyalty UI
function updateLoyaltyUI(pointsBalance) {
  const pointsElement = document.querySelector('[data-points-balance]');
  if (pointsElement) {
    pointsElement.textContent = pointsBalance;
  }
}

// Function to update VIP tier display
function updateVipTierDisplay(vipTier) {
  const tierElement = document.querySelector('[data-vip-tier]');
  const tierNameElement = document.querySelector('[data-vip-tier-name]');
  if (tierElement) {
    if (vipTier) {
      if (tierNameElement) {
        tierNameElement.textContent = vipTier;
      }
      tierElement.style.display = 'inline';
    } else {
      tierElement.style.display = 'none';
    }
  }
}

// Sync birthday to 99minds
async function syncBirthdayToMinds(dateOfBirth) {
  try {
    const sdk = await window.sdk.onReady();
    await sdk.resource.postUpdateCustomer({
      customer: { birthday_str: dateOfBirth },
    });
    console.log('✅ Birthday synced to 99minds:', dateOfBirth);
  } catch (error) {
    console.error('Failed to sync birthday to 99minds:', error);
  }
}

// Ensure customer is opted into loyalty program and sync birthday
async function ensureLoyaltyOptIn() {
  try {
    const sdk = await window.sdk.onReady();
    const response = await sdk.resource.postCustomer();

    const customerInfo = response?.data?.customer || {};

    console.log('🧑 Customer Info:', customerInfo);

    if (!customerInfo) {
      return null;
    }

    // Check if opt-in is needed
    const needsOptIn = !customerInfo.has_opted_in_loyalty;

    // Check if birthday sync is needed
    const shopifyBirthday = window.Shopify?.customerBirthday || null;
    const mindsBirthday = customerInfo.birthday_str || null;
    const needsBirthdaySync = shopifyBirthday && !mindsBirthday;

    console.log('🎂 Birthday sync check:', { shopifyBirthday, mindsBirthday, needsBirthdaySync });

    // Build combined update payload if anything needs syncing
    if (needsOptIn || needsBirthdaySync) {
      const updatePayload = {};
      if (needsOptIn) updatePayload.opt_in_loyalty = true;
      if (needsBirthdaySync) updatePayload.birthday_str = shopifyBirthday;

      await sdk.resource.postUpdateCustomer({
        customer: updatePayload,
      });

      if (needsOptIn) console.log('✅ Customer opted into loyalty');
      if (needsBirthdaySync) console.log('✅ Birthday synced to 99minds:', shopifyBirthday);
    }

    // Only run tagging + UI refresh when opt-in was needed
    if (needsOptIn) {
      // Tag customer in Shopify for segmentation
      const backendUrl = window.Shopify?.backendUrl;
      const storeIdentifier = window.Shopify?.storeIdentifier;
      const customerId = window.Shopify?.customerId;

      if (backendUrl && customerId) {
        try {
          await fetch(`${backendUrl}/api/customers/add-tags?store=${storeIdentifier}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ customerId }),
          });
          console.log('Tagged customer as loyalty-opt-in:online-store');
        } catch (err) {
          console.error('Failed to tag customer:', err);
        }
      }

      // Wait 1 second and refetch customer info and points balance
      setTimeout(async () => {
        const newResponse = await sdk.resource.postCustomer();
        const pointsBalance = await sdk.resource.getPointsBalance();

        const refreshedCustomerInfo = newResponse?.data?.customer || {};

        console.log('🧑 Refreshed Customer Info:', refreshedCustomerInfo);
        console.log('🧑 Refreshed Points Balance:', pointsBalance);

        // Update UI with refreshed data
        const vipTier = refreshedCustomerInfo?.vip_tier?.name || null;
        updateVipTierDisplay(vipTier);

        if (pointsBalance?.data?.point_balance) {
          updateLoyaltyUI(pointsBalance.data.point_balance);
        } else {
          updateLoyaltyUI(0);
        }
      }, 1000);
    }

    return customerInfo?.vip_tier?.name || null;
  } catch (error) {
    console.error('Error checking/updating loyalty opt-in:', error);
    return null;
  }
}

// Fetch and update points
async function fetchAndUpdatePoints() {
  try {
    const sdk = await window.sdk.onReady();
    const pointsBalance = await sdk.resource.getPointsBalance();

    // Ensure opt-in and get VIP tier
    const vipTier = await ensureLoyaltyOptIn();

    if (pointsBalance?.data?.point_balance) {
      updateLoyaltyUI(pointsBalance.data.point_balance);
    } else {
      updateLoyaltyUI(0);
    }
    updateVipTierDisplay(vipTier);

    return pointsBalance;
  } catch (error) {
    console.error('Error fetching points:', error);
    return null;
  }
}

// Fetch Points Transaction History
async function fetchPointsTransactionHistory() {
  try {
    const sdk = await window.sdk.onReady();
    const pointsTransactions = await sdk.resource.getPointsTransactions();

    return pointsTransactions;
  } catch (error) {
    console.error('Error fetching points transactions:', error);
    return null;
  }
}

// Get rewards
async function getRewards() {
  try {
    const sdk = await window.sdk.onReady();
    const rewards = await sdk.resource.getRewards();
    console.log('🖖', rewards);

    return rewards;
  } catch (error) {
    console.error('Error fetching rewards:', error);
    return null;
  }
}

// Initialize when SDK is ready
document.addEventListener('MindsSDKInitialized', (event) => {
  const sdk = event.detail.sdk;
  fetchAndUpdatePoints();

  fetchPointsTransactionHistory();
  getRewards();
});

// Also try with Promise approach as fallback
fetchAndUpdatePoints();
fetchPointsTransactionHistory();
getRewards();

// ========================================
// Transaction History Modal
// ========================================

// Map transaction types to display text
const TRANSACTION_TYPE_MAP = {
  RELOAD: 'Earned',
  REDEMPTION: 'Spent',
  MANUAL_CREDIT: 'Earned',
  MANUAL_DEBIT: 'Spent',
  EXPIRED: 'Expired',
};

// Format date to match design: "Mar 21, 01:27 PM"
function formatTransactionDate(timestamp) {
  const date = new Date(timestamp);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const month = months[date.getMonth()];
  const day = String(date.getDate()).padStart(2, '0');

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  return `${month} ${day}, ${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
}

// Create transaction item HTML
function createTransactionItem(transaction) {
  const actionText = TRANSACTION_TYPE_MAP[transaction.transaction_type] || 'Unknown';
  const formattedDate = formatTransactionDate(transaction.transaction_timestamp);

  // Determine if this is a credit (earned) or debit (spent/expired) transaction
  const isCreditTransaction = ['RELOAD', 'MANUAL_CREDIT'].includes(transaction.transaction_type);
  const iconClass = isCreditTransaction ? 'rewards-transaction-icon--credit' : 'rewards-transaction-icon--debit';

  return `
    <div class="rewards-transaction-item">
      <div class="rewards-transaction-icon ${iconClass}">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <div class="rewards-transaction-details">
        <div class="rewards-transaction-amount">${actionText} ${transaction.amount} ⭐</div>
        <div class="rewards-transaction-date">${formattedDate}</div>
      </div>
    </div>
  `;
}

// Render transactions into the modal
function renderTransactions(transactions) {
  const listContainer = document.getElementById('rewards-transaction-list');
  const loadingContainer = document.getElementById('rewards-transaction-loading');
  const emptyContainer = document.getElementById('rewards-transaction-empty');

  if (!listContainer) {
    console.error('Transaction list container not found');
    return;
  }

  // Hide loading
  if (loadingContainer) loadingContainer.style.display = 'none';

  if (!transactions || transactions.length === 0) {
    // Show empty state
    if (emptyContainer) emptyContainer.style.display = 'block';
    return;
  }

  // Render transactions
  const transactionsHTML = transactions.map(createTransactionItem).join('');
  listContainer.innerHTML = transactionsHTML;
  listContainer.style.display = 'flex';
}

// Show error state
function showTransactionError() {
  const listContainer = document.getElementById('rewards-transaction-list');
  const loadingContainer = document.getElementById('rewards-transaction-loading');
  const emptyContainer = document.getElementById('rewards-transaction-empty');
  const errorContainer = document.getElementById('rewards-transaction-error');

  if (loadingContainer) loadingContainer.style.display = 'none';
  if (listContainer) listContainer.style.display = 'none';
  if (emptyContainer) emptyContainer.style.display = 'none';
  if (errorContainer) errorContainer.style.display = 'block';
}

// Fetch and display transaction history
async function loadTransactionHistory() {
  try {
    // Fetch transaction data
    const response = await fetchPointsTransactionHistory();

    const transactionsData = response?.data?.points_transactions;

    renderTransactions(transactionsData);
  } catch (error) {
    console.error('Error loading transaction history:', error);
    showTransactionError();
  }
}

// Initialize transaction history modal
function initRewardsHistory() {
  const openButton = document.querySelector('[data-open-rewards-history]');
  const modal = document.getElementById('rewards-transaction-history-modal');

  if (!openButton || !modal) {
    console.warn('Rewards history button or modal not found');
    return;
  }

  // Add click handler to button
  openButton.addEventListener('click', (e) => {
    e.preventDefault();

    // Reset to loading state
    const listContainer = document.getElementById('rewards-transaction-list');
    const loadingContainer = document.getElementById('rewards-transaction-loading');
    const emptyContainer = document.getElementById('rewards-transaction-empty');
    const errorContainer = document.getElementById('rewards-transaction-error');

    if (listContainer) {
      listContainer.style.display = 'none';
      listContainer.innerHTML = '';
    }
    if (loadingContainer) loadingContainer.style.display = 'flex';
    if (emptyContainer) emptyContainer.style.display = 'none';
    if (errorContainer) errorContainer.style.display = 'none';

    // Open modal
    modal.show();

    // Load transactions
    loadTransactionHistory();
  });
}

// Initialize transaction history when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRewardsHistory);
} else {
  initRewardsHistory();
}

// Export for manual testing
window.loyaltyUtils = {
  fetchAndUpdatePoints,
  updateLoyaltyUI,
  updateVipTierDisplay,
  ensureLoyaltyOptIn,
  fetchPointsTransactionHistory,
  getRewards,
  loadTransactionHistory,
  syncBirthdayToMinds,
};

// ========================================
// How to Redeem Modal
// ========================================

// Cache for prefetched content
let cachedHowToRedeemContent = null;

// Fetch page content
async function fetchPageContent(pageHandle) {
  try {
    const response = await fetch(`/pages/${pageHandle}`);

    if (!response.ok) {
      throw new Error(`Failed to fetch page: ${response.status} ${response.statusText}`);
    }

    const html = await response.text();
    return html;
  } catch (error) {
    console.error('Error fetching page content:', error);
    throw error;
  }
}

// Parse and extract page content
function extractPageContent(html) {
  // Parse the HTML string
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // Try to find the main page content
  // Shopify page templates typically have the content in .shopify-section or main tags
  let content = doc.querySelector('.shopify-section--main-page .page__content');

  // Fallback selectors if the primary selector doesn't find content
  if (!content) {
    content =
      doc.querySelector('main .page__content') ||
      doc.querySelector('.main-page-wrapper') ||
      doc.querySelector('[data-section-type="page"]') ||
      doc.querySelector('main');
  }

  if (content) {
    // Clone the content to avoid modifying the original
    const contentClone = content.cloneNode(true);

    // Remove footer elements
    const footers = contentClone.querySelectorAll('footer, .footer, [data-section-type="footer"]');
    footers.forEach((footer) => footer.remove());

    // Remove allow-transparent-header attribute to prevent header transparency issues
    const transparentHeaderElements = contentClone.querySelectorAll('[allow-transparent-header]');
    transparentHeaderElements.forEach((element) => element.removeAttribute('allow-transparent-header'));

    return contentClone.innerHTML;
  } else {
    console.warn('Could not find page content in standard locations');
    // Return the full body content as a last resort
    return doc.body.innerHTML;
  }
}

// Show loading state
function showHowToRedeemLoading() {
  const loadingContainer = document.getElementById('how-to-redeem-loading');
  const contentContainer = document.getElementById('how-to-redeem-content');
  const errorContainer = document.getElementById('how-to-redeem-error');

  if (loadingContainer) loadingContainer.style.display = 'flex';
  if (contentContainer) {
    contentContainer.style.display = 'none';
    contentContainer.innerHTML = '';
  }
  if (errorContainer) errorContainer.style.display = 'none';
}

// Show content
function showHowToRedeemContent(content) {
  const loadingContainer = document.getElementById('how-to-redeem-loading');
  const contentContainer = document.getElementById('how-to-redeem-content');
  const errorContainer = document.getElementById('how-to-redeem-error');

  if (loadingContainer) loadingContainer.style.display = 'none';
  if (errorContainer) errorContainer.style.display = 'none';

  if (contentContainer) {
    contentContainer.innerHTML = content;
    contentContainer.style.display = 'block';
  }
}

// Show error state
function showHowToRedeemError() {
  const loadingContainer = document.getElementById('how-to-redeem-loading');
  const contentContainer = document.getElementById('how-to-redeem-content');
  const errorContainer = document.getElementById('how-to-redeem-error');

  if (loadingContainer) loadingContainer.style.display = 'none';
  if (contentContainer) contentContainer.style.display = 'none';
  if (errorContainer) errorContainer.style.display = 'block';
}

// Load and display page content
async function loadHowToRedeemContent(pageHandle, useCache = true) {
  showHowToRedeemLoading();

  try {
    // Use cached content if available
    if (useCache && cachedHowToRedeemContent) {
      showHowToRedeemContent(cachedHowToRedeemContent);
      return;
    }

    const html = await fetchPageContent(pageHandle);
    const content = extractPageContent(html);

    // Cache the content for future use
    cachedHowToRedeemContent = content;

    showHowToRedeemContent(content);
  } catch (error) {
    console.error('Error loading how to redeem content:', error);
    showHowToRedeemError();
  }
}

// Prefetch page content in the background
async function prefetchHowToRedeemContent(pageHandle) {
  try {
    const html = await fetchPageContent(pageHandle);
    const content = extractPageContent(html);
    cachedHowToRedeemContent = content;
  } catch (error) {
    console.error('Error prefetching how to redeem content:', error);
  }
}

// Initialize how to redeem modal
function initHowToRedeemModal() {
  const redeemLink = document.querySelector('[data-how-to-redeem-link]');
  const modal = document.getElementById('how-to-redeem-modal');

  if (!redeemLink || !modal) {
    console.error('How to redeem link or modal not found - feature not configured');
    return;
  }

  const pageHandle = redeemLink.getAttribute('data-page-handle');

  if (!pageHandle) {
    console.error('Page handle not found on how to redeem link');
    return;
  }

  // Prefetch content in the background after a short delay
  setTimeout(() => {
    prefetchHowToRedeemContent(pageHandle);
  }, 1000);

  // Add click handler to link
  redeemLink.addEventListener('click', (e) => {
    e.preventDefault();

    // Open modal
    modal.show();

    // Load page content (will use cache if available)
    loadHowToRedeemContent(pageHandle);
  });
}

// Initialize how to redeem modal when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHowToRedeemModal);
} else {
  initHowToRedeemModal();
}
